import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { alertError, alertSuccess } from '../../components/Toast';
import { setData } from '../../core/redux/app/Actions';
import { saveAeService } from '../../core/utils/AeService';
import ModalServiceAesthetic from '../../screens/ModalServiceAesthetic/ModalServiceAesthetic';
import { supabase } from '../../supabaseClient';
import { compareValues } from '../ModalClients/ModalClientsContainer';

const ModalServiceAestheticContainer = ({ setIsModalToCreateServiceOpen }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const id = location.pathname.split('/')[3];
  const params = useParams();
  const isNew = params.id === '0';
  const [values, setValues] = useState({});
  const [oldValues, setOldValues] = useState({});
  const reloadAeServices = useSelector(
    (state) => state.app.reloadAeServices || false
  );
  const company = useSelector((state) => state.app.company || {});
  const user = useSelector((state) => state.app.user || {});

  const loadData = async () => {
    let { data, error } = await supabase
      .from('AestheticServices')
      .select('*')
      .eq('id', id)
      .is('deleted_at', null);

    if (!error) {
      const item = data[0];
      setValues({ ...item });
      setOldValues({ ...item });
    }
  };

  useEffect(() => {
    if (id !== '0') {
      loadData();
    }
  }, [id]);

  useEffect(() => {
    if (location && location.state) {
      setOldValues({ ...location.state });
      setValues({ ...location.state });
    }
  }, [location]);

  useEffect(() => {
    const path = location.pathname.split('/')[1];
    dispatch(
      setData({ [`compareValues_${path}`]: compareValues(oldValues, values) })
    );
  }, [values, oldValues]);

  const closeModal = () => {
    if (compareValues(oldValues, values)) {
      Swal.fire({
        title: 'Deseja sair sem salvar?',
        showCancelButton: true,
        showConfirmButton: false,
        showDenyButton: true,
        icon: 'warning',
        text: 'Ao sair, seus dados serão descartados.',
        denyButtonText: `Sair`,
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isDenied) {
          setIsModalToCreateServiceOpen
            ? setIsModalToCreateServiceOpen(false)
            : history.push('/aesthetic');
        }
      });
    } else {
      setIsModalToCreateServiceOpen
        ? setIsModalToCreateServiceOpen(false)
        : history.push('/aesthetic');
    }
  };

  const onChange = (field, value) => {
    setValues((values) => ({ ...values, [field]: value }));
  };

  const onSave = async () => {
    try {
      if (values && !values.title) {
        alertError('Título é obrigatório.');
        return;
      }
      if (values && !values.p_value) {
        alertError('Quantidade ou valor para o serviço é obrigatório.');
        return;
      }
      await saveAeService(values.id, {
        ...values,
        module_type: 1,
        id_company: company.id,
        quantity: values?.quantity || 1,
      });
      alertSuccess('Sucesso ao salvar o serviço!');
      setIsModalToCreateServiceOpen
        ? setIsModalToCreateServiceOpen(false)
        : history.push('/aesthetic');
      dispatch(setData({ reloadAeServices: !reloadAeServices }));
    } catch (error) {
      alertError('Erro ao salvar o serviço, tente novamente mais tarde.');
    }
  };

  const onRemove = async () => {
    const confirmation = await Swal.fire({
      title: 'Deseja mesmo excluir?',
      showCancelButton: true,
      showConfirmButton: false,
      showDenyButton: true,
      icon: 'warning',
      text: 'Seus dados serão completamente perdidos!',
      denyButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
    });

    if (confirmation.isDenied) {
      if (values && values.id) {
        const { data, error } = await supabase
          .from('AestheticServices')
          .update({ deleted_at: new Date(), deleted_by: user.id })
          .eq('id', values.id);

        if (!error) {
          alertSuccess('Removido com sucesso!');
          setIsModalToCreateServiceOpen
            ? setIsModalToCreateServiceOpen(false)
            : history.push('/aesthetic');
          dispatch(setData({ reloadAeServices: !reloadAeServices }));
        } else {
          alertError('Erro ao remover, tente novamente mais tarde');
        }
      } else {
        alertError('Erro ao remover, tente novamente mais tarde');
      }
    } else {
      setIsModalToCreateServiceOpen
        ? setIsModalToCreateServiceOpen(false)
        : history.push('/aesthetic');
    }
  };

  return (
    <ModalServiceAesthetic
      compareValues={compareValues(oldValues, values)}
      closeModal={closeModal}
      onChange={onChange}
      values={values}
      isNew={isNew}
      onSave={onSave}
      onRemove={onRemove}
    />
  );
};

export default ModalServiceAestheticContainer;
